"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactToastify = require("react-toastify");

var _reactMoment = _interopRequireDefault(require("react-moment"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledRow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 0;\n  font-size: 0.875rem;\n  margin: 1.5rem 0 1.5rem;\n"])));

var StyledLabel = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 0.325rem;\n  font-size: 0.75rem;\n  text-align: center;\n  color: ", ";\n"])), function (props) {
  return props.theme.colorLabel;
});

var StyledValue = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  text-align: center;\n  font-weight: 700;\n"])));

var WalletButtonsDepositLimit = function WalletButtonsDepositLimit(_ref) {
  var onError = _ref.onError,
      translations = _ref.translations,
      currencySymbol = _ref.currencySymbol,
      dateLocale = _ref.dateLocale;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSaving = _useState2[0],
      setSaving = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      depositLimit = _useState6[0],
      setDepositLimit = _useState6[1];

  var _useState7 = (0, _react.useState)({
    depositLimitAmount: undefined,
    depositLimitDuration: undefined
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      form = _useState8[0],
      setForm = _useState8[1];

  var depositLimitAmount = form.depositLimitAmount,
      depositLimitDuration = form.depositLimitDuration;
  var hasPendingLimit = depositLimit !== null && depositLimit !== void 0 && depositLimit.pending ? true : undefined;
  var depositLimitToShow = hasPendingLimit === true && depositLimit ? depositLimit === null || depositLimit === void 0 ? void 0 : depositLimit.pending : depositLimit === null || depositLimit === void 0 ? void 0 : depositLimit.active;
  var formIsValid = depositLimitToShow && depositLimitToShow.amount !== depositLimitAmount || depositLimitToShow && depositLimitToShow.duration !== depositLimitDuration;
  var shouldShowForm = depositLimitToShow && depositLimitToShow.amount === null || hasPendingLimit && depositLimit.pending.amount === null;
  var shouldShowRemove = depositLimitToShow && depositLimitToShow.amount !== null;
  var shouldShowSave = hasPendingLimit && depositLimit.pending.amount === null || !hasPendingLimit && depositLimitToShow && depositLimitToShow.amount === null;

  var saveDepositLimit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
      var _depositLimitRes$data, depositLimitRes;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSaving(true);
              _context.prev = 1;
              _context.next = 4;
              return _axios.default.put("/wallet/deposit-limit", params);

            case 4:
              depositLimitRes = _context.sent;
              setSaving(false);
              setDepositLimit(depositLimitRes === null || depositLimitRes === void 0 ? void 0 : (_depositLimitRes$data = depositLimitRes.data) === null || _depositLimitRes$data === void 0 ? void 0 : _depositLimitRes$data.data);

              _reactToastify.toast.success(translations.depositLimitUpdated);

              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              setSaving(false);

              _reactToastify.toast.error(translations.depositLimitError);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function saveDepositLimit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleTextboxChanged = function handleTextboxChanged(e) {
    var _e$target = e.target,
        value = _e$target.value,
        name = _e$target.name;
    setForm(_objectSpread(_objectSpread({}, form), {}, _defineProperty({}, name, value)));
  };

  var handleSelectChanged = function handleSelectChanged(e) {
    var _e$target2 = e.target,
        value = _e$target2.value,
        name = _e$target2.name;
    setForm(_objectSpread(_objectSpread({}, form), {}, _defineProperty({}, name, +value)));
  };

  (0, _react.useEffect)(function () {
    if (!depositLimitAmount && depositLimit) {
      setForm(_objectSpread(_objectSpread({}, form), {}, {
        depositLimitAmount: depositLimit.amount,
        depositLimitDuration: depositLimit.duration
      }));
    }
  }, [depositLimit]);
  (0, _react.useEffect)(function () {
    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _depositLimitRes$data2, depositLimitRes, response;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _axios.default.get("/wallet/deposit-limit");

            case 3:
              depositLimitRes = _context2.sent;
              setDepositLimit(depositLimitRes === null || depositLimitRes === void 0 ? void 0 : (_depositLimitRes$data2 = depositLimitRes.data) === null || _depositLimitRes$data2 === void 0 ? void 0 : _depositLimitRes$data2.data);
              setLoading(false);
              _context2.next = 13;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              response = _context2.t0.response;
              setLoading(false);
              onError(response);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }))();
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.SmallPrint, null, translations.depositLimitMessage)), depositLimit && depositLimit.active && /*#__PURE__*/_react.default.createElement(StyledRow, null, depositLimit && depositLimit.active && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StyledLabel, null, translations.yourCurrentLimit), /*#__PURE__*/_react.default.createElement(StyledValue, null, currencySymbol, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.PenceToPounds, null, depositLimit.active.amount), "/", " ", depositLimit.active.duration === 1 ? "day" : depositLimit.active.duration === 7 ? "week" : "month")), depositLimit && depositLimit.pending && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StyledLabel, null, translations.yourPendingLimit), /*#__PURE__*/_react.default.createElement(StyledValue, null, currencySymbol, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.PenceToPounds, null, depositLimit.pending.amount), "/", " ", depositLimit.pending.duration === 1 ? translations.day : depositLimit.pending.duration === 7 ? translations.week : translations.month))), hasPendingLimit && depositLimitToShow && /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Alert, {
    margin: "0 0 1rem"
  }, translations.limitWillTakeEffect, " ", depositLimitToShow && depositLimitToShow.effectiveFrom && /*#__PURE__*/_react.default.createElement(_reactMoment.default, {
    locale: dateLocale || "en-gb",
    fromNow: true,
    date: depositLimitToShow.effectiveFrom
  })), shouldShowForm && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormSelect, {
    name: "depositLimitAmount",
    value: depositLimitAmount,
    onChange: handleSelectChanged
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: 1000
  }, currencySymbol, "10"), /*#__PURE__*/_react.default.createElement("option", {
    value: 2000
  }, currencySymbol, "20"), /*#__PURE__*/_react.default.createElement("option", {
    value: 3000
  }, currencySymbol, "30"), /*#__PURE__*/_react.default.createElement("option", {
    value: 4000
  }, currencySymbol, "40"), /*#__PURE__*/_react.default.createElement("option", {
    value: 5000
  }, currencySymbol, "50"), /*#__PURE__*/_react.default.createElement("option", {
    value: 7500
  }, currencySymbol, "75"), /*#__PURE__*/_react.default.createElement("option", {
    value: 10000
  }, currencySymbol, "100"), /*#__PURE__*/_react.default.createElement("option", {
    value: 20000
  }, currencySymbol, "200"), /*#__PURE__*/_react.default.createElement("option", {
    value: 30000
  }, currencySymbol, "300"), /*#__PURE__*/_react.default.createElement("option", {
    value: 40000
  }, currencySymbol, "400"), /*#__PURE__*/_react.default.createElement("option", {
    value: 50000
  }, currencySymbol, "500"))), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormSelect, {
    name: "depositLimitDuration",
    value: depositLimitDuration,
    onChange: handleSelectChanged
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: 1
  }, "1 ", translations.day), /*#__PURE__*/_react.default.createElement("option", {
    value: 7
  }, "7 ", translations.days), /*#__PURE__*/_react.default.createElement("option", {
    value: 28
  }, "28 ", translations.days)))), shouldShowRemove && /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    size: "sm",
    disabled: isSaving,
    isLoading: isSaving,
    isDanger: true,
    onClick: function onClick() {
      return saveDepositLimit({
        amount: null,
        duration: null
      });
    }
  }, translations.remove, " ", translations.limit), shouldShowSave && /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    disabled: !formIsValid || isSaving,
    isLoading: isSaving,
    onClick: function onClick() {
      return saveDepositLimit({
        amount: depositLimitAmount || 1000,
        duration: depositLimitDuration || 1
      });
    },
    size: "sm"
  }, translations.save));
};

var _default = WalletButtonsDepositLimit;
exports.default = _default;